import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { postRequest, putRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import ConsultantForm from '../Registration/ConsultantForm';
import InterestDetails from '../ConsultantInterest/InterestDetails';
import './ConsultantCreateConsultantInterest.scss';

class ConsultantCreateConsultantInterest extends Component {
  constructor(props) {
    super(props);

    this.tagTypes = {
      area_of_expertises: 'Functional areas',
      therapeutic_areas: 'Therapeutic areas',
      therapies: 'Therapies',
      development_phases: 'Development phases',
      regulatory_pathways: 'Regulatory pathways',
      disease_codes: 'Disease codes',
      accreditations: 'Certification',
    };

    const checkboxes = { availability: null };
    if (props.project.employment_type === 'consulting') {
      checkboxes.tax_reporting = null;
    } else if (props.project.us_work_authorization_required) {
      checkboxes.work_authorization = null;
    }

    this.state = {
      submitAttempted: false,
      disabled: true,
      resume: props.resume,
      checkboxes,
      requestedHourlyRate: props.consultantInterest ? props.consultantInterest.response.requested_hourly_rate : '',
      location: props.consultantInterest ? props.consultantInterest.response.location : '',
      modalOpen: props.modalOpen,
      openToRelocation: props.consultantInterest ? props.consultantInterest.response.open_to_relocation : false,
    };

    this.missingRequiredFields = this.missingRequiredFields.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleToggleCheckbox = this.handleToggleCheckbox.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleUpdateResume = this.handleUpdateResume.bind(this);
    this.handleWithdrawApplication = this.handleWithdrawApplication.bind(this);
    this.isHybridOrInOffice = this.isHybridOrInOffice.bind(this);
    this.handleOpenToggleCheckbox = this.handleOpenToggleCheckbox.bind(this);
  }

  missingRequiredFields() {
    const { project, consultantInterest } = this.props;
    const {
      resume, checkboxes, requestedHourlyRate, location,
    } = this.state;

    if (consultantInterest) return false;

    const isHybridOrInOffice = this.isHybridOrInOffice();

    const areRequiredCheckboxesChecked = Object.entries(checkboxes).every(([key, value]) => value);

    const isHourlyRateValid = project.employment_type === 'full_time' || /^[0-9]+$/.test(requestedHourlyRate);

    const isLocationValid = isHybridOrInOffice ? (location && location !== '') : true;

    return !(
      resume
      && areRequiredCheckboxesChecked
      && isHourlyRateValid
      && !this.missingRequiredExpertise()
      && isLocationValid
    );
  }

  handleToggleCheckbox(idx, value = 'toggle') {
    return () => {
      const { checkboxes } = this.state;
      const newValue = { ...checkboxes };
      if (value === 'toggle') {
        newValue[idx] = !newValue[idx];
      } else {
        newValue[idx] = value;
      }

      this.setState({ checkboxes: newValue });
    };
  }

  handleOpenToggleCheckbox() {
    const { openToRelocation } = this.state;
    this.setState({ openToRelocation: !openToRelocation });
  }

  isHybridOrInOffice() {
    const { project } = this.props;
    const info = project?.office_and_worktype_information?.toLowerCase() || '';

    return (
      info.includes('hybrid')
      || info.includes('in office')
      || info.includes('onsite')
    );
  }

  handleTextChange(field) {
    return (e) => {
      if (field === 'requestedHourlyRate') {
        this.setState({ requestedHourlyRate: e.target.value });
      } else if (field === 'location') {
        this.setState({ location: e });
      }
    };
  }

  handleUpdateResume(resume) {
    analyticsTrack('Added/Updated Resume', { location: 'Consultant Interest' });
    this.setState({ resume: resume.resume || resume });
  }

  handleSubmit() {
    const {
      formUrl, project, csrfToken, consultantInterest,
    } = this.props;
    const {
      resume, requestedHourlyRate, openToRelocation, location,
    } = this.state;
    const params = {
      consultant_interest: {
        project_id: project.id,
        resume_id: resume && resume.id,
        response: {
          requested_hourly_rate: requestedHourlyRate,
          open_to_relocation: openToRelocation,
          location,
        },
      },
      authenticity_token: csrfToken,
      resource_id: project.resource_id,
    };

    if (this.missingRequiredFields()) {
      this.setState({ submitAttempted: true });
    } else if (consultantInterest) {
      putRequest(`${formUrl}/${consultantInterest.id}`, params);
    } else {
      postRequest(formUrl, params).then(() => {
        window.location.href = `/projects/${project.resource_id}/?interest_submitted=true`;
      });
    }
  }

  handleWithdrawApplication() {
    const { withdrawPath, csrfToken, project } = this.props;
    putRequest(withdrawPath, {}, csrfToken)
      .then(() => {
        this.setState({ showModal: false });
        window.location.href = `/projects/${project.resource_id}`;
      });
  }

  missingRequiredExpertise() {
    const { project } = this.props;

    return Object.keys(this.tagTypes).reduce((agg, type) => agg.concat(project.missing_priority_tags[type] || []), []).length > 0;
  }

  render() {
    const {
      project, consultantInterest, uploadResumeUrl, csrfToken, formUrl, sourced, modalOpen,
      profilePath, invitedEmail, signInUrl, googleOmniauthUrl, msOmniauthUrl, referralToken,
      otherOpportunities, showWithdrawButton,
    } = this.props;
    const {
      resume, submitAttempted, checkboxes, requestedHourlyRate, location, openToRelocation,
    } = this.state;

    return (
      <div className="consultant-interest-application">
        <ModalTrigger
          triggerText={consultantInterest ? 'View Application' : 'Start Application'}
          buttonStyles={consultantInterest ? 'body-text-2 demibold pl-0' : 'btn btn-primary bigger-button full-width'}
          cancelButtonText={consultantInterest ? 'Close' : 'Finish Later'}
          submitButtonText={consultantInterest ? 'Update application' : 'Submit application'}
          handleSubmit={this.handleSubmit}
          triggerType={consultantInterest ? 'link' : 'button'}
          idKey={profilePath ? 'consultant-interest-application' : 'consultant-registration-modal'}
          cancelButton
          showFooter={!!profilePath}
          closeAfterSubmit={!this.missingRequiredFields()}
          showModal={modalOpen}
          showWithdrawButton={showWithdrawButton}
          handleWithdrawApplication={this.handleWithdrawApplication}
          modalSize={profilePath ? 'lg' : 'md'}
        >
          { profilePath
            ? (
              <InterestDetails
                project={project}
                uploadResumeUrl={uploadResumeUrl}
                profilePath={profilePath}
                csrfToken={csrfToken}
                resume={resume}
                formUrl={formUrl}
                missingRequiredFields={this.missingRequiredFields()}
                missingRequiredExpertise={this.missingRequiredExpertise()}
                handleToggleCheckbox={this.handleToggleCheckbox}
                handleTextChange={this.handleTextChange}
                handleUpdateResume={this.handleUpdateResume}
                requestedHourlyRate={requestedHourlyRate}
                location={location}
                submitAttempted={submitAttempted}
                checkboxes={checkboxes}
                submitted={consultantInterest !== null}
                isHybridOrInOffice={this.isHybridOrInOffice()}
                openToRelocation={openToRelocation}
                handleOpenToggleCheckbox={this.handleOpenToggleCheckbox}
              />
            )
            : (
              <div className="style-guide consultant-registration-modal registration form p-2 p-md-4 shadow-none">
                <h1 className="hero-header">Stop Searching, Start Working</h1>
                <ConsultantForm
                  csrfToken={csrfToken}
                  invitedEmail={invitedEmail}
                  signInUrl={signInUrl}
                  googleOmniauthUrl={googleOmniauthUrl}
                  msOmniauthUrl={msOmniauthUrl}
                  projectResourceId={project.resource_id}
                  referralToken={referralToken}
                  sourced={sourced}
                  postOnboardUrl={otherOpportunities ? '/opportunities' : null}
                />
              </div>
            )}
        </ModalTrigger>
      </div>
    );
  }
}

ConsultantCreateConsultantInterest.propTypes = {
  formUrl: PropTypes.string.isRequired,
  project: PropTypes.shape({
    id: PropTypes.number,
    us_work_authorization_required: PropTypes.bool,
    employment_type: PropTypes.string,
  }).isRequired,
  consultantInterest: PropTypes.shape({
    response: PropTypes.shape({
      requested_hourly_rate: PropTypes.string,
    }),
  }),
  resume: PropTypes.shape({}),
  csrfToken: PropTypes.string.isRequired,
  uploadResumeUrl: PropTypes.string.isRequired,
  profilePath: PropTypes.string.isRequired,
  signInUrl: PropTypes.string,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  invitedEmail: PropTypes.string,
  referralToken: PropTypes.string,
  sourced: PropTypes.string,
  modalOpen: PropTypes.bool,
  otherOpportunities: PropTypes.bool,
  showWithdrawButton: PropTypes.bool,
  withdrawPath: PropTypes.string.isRequired,
};

ConsultantCreateConsultantInterest.defaultProps = {
  consultantInterest: null,
  resume: null,
  invitedEmail: null,
  referralToken: null,
  signInUrl: null,
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  sourced: null,
  modalOpen: false,
  otherOpportunities: false,
  showWithdrawButton: false,
};

export default ConsultantCreateConsultantInterest;
